import { PageGen, PdfRect } from '../pdf/pdf';

export const IColorSchemaSymbol = Symbol('IColorSchema');

export interface IColorSchema {
  readonly name: string;
  drawPage(page: PageGen, rect: PdfRect, inner: PdfRect, pageNumber: number): void;
  drawWindow(page: PageGen, rect: PdfRect, index: number, counter?: string, title?: string): void;
  drawResult(page: PageGen, rect: PdfRect): void;
  calcContent(rect: PdfRect): PdfRect;
}
